import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useUpdateFormularioPECATAByID = () => {
  const [loadingUpdateFormularioPECATAById, setLoadingCreateFormularioPECATA] = useState(false);
  const [successUpdateFormularioPECATAById, setSuccessCreateFormularioPECATA] = useState(false);
  const [errorUpdateFormularioPECATAById, setErrorCreateFormularioPECATA] = useState(null);
  const [dataUpdateFormularioPECATAById, setDataFormularioPECATA] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  )


  //UPDATE
  const updateFormularioPECATAById = async (userId:string , formId: string, data:any, _cb?:(data:any)=>void) => {
    setLoadingCreateFormularioPECATA(true);
    setSuccessCreateFormularioPECATA(false);
    setErrorCreateFormularioPECATA(null);

    apiRecord.updateSolicitudPecataByID(userId, formId, data).then((res: any) => {
      setLoadingCreateFormularioPECATA(false);
      setSuccessCreateFormularioPECATA(true);
      setDataFormularioPECATA(res.data);
      if (typeof _cb === "function") {
        _cb(res.data);
      }

    }).catch((err:any) => {
      console.log(err)
      setLoadingCreateFormularioPECATA(false);
      setErrorCreateFormularioPECATA(err.response.data)
    })
  }

  return {
    updateFormularioPECATAById,
    loadingUpdateFormularioPECATAById,
    successUpdateFormularioPECATAById,
    errorUpdateFormularioPECATAById,
    dataUpdateFormularioPECATAById
  }

}

export default useUpdateFormularioPECATAByID;
